import type { IconData } from '@stacksjs/iconify-core'

export const textFormattingJustified: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M0 0h16v4H0zm0 6h16v4H0zm16 6H0v4h16z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default textFormattingJustified
